export type LegalDocumentType = 'legal_entity' | 'power_of_attorney'

export type DocumentType =
  | 'document_back_photo'
  | 'document_front_photo'
  | 'self_photo'
  | LegalDocumentType

export type DocumentStatus =
  | 'pending'
  | 'waiting_manual'
  | 'received'
  | 'rejected'

export enum DocumentStatusEnum {
  Pending = 'pending',
  WaitingManual = 'waiting_manual',
  Received = 'received',
  Rejected = 'rejected',
}

export enum DocumentTypeEnum {
  DocumentBackPhoto = 'document_back_photo',
  DocumentFrontPhoto = 'document_front_photo',
  SelfPhoto = 'self_photo',
  LegalEntity = 'legal_entity',
  PowerOfAttorney = 'power_of_attorney',
}

export type RequiredDocument = {
  type: DocumentType
  status: DocumentStatus
}

export type RequiredDocumentsResponse = {
  required_documents: RequiredDocument[]
}

export enum UploadGroupEnum {
  Legal = 'legal',
  Personal = 'personal',
}
